module.exports = __webpack_public_path__ + "assets/discount-2944c8.svg";